<template>
  <svg :x="mouldingPlateX" :y="mouldingPlateY" :width="`${mouldingPlateWidth}in`" :height="`${mouldingPlateHeight}in`" xmlns="http://www.w3.org/2000/svg">
    <image
      :href="mouldingPlateImageUrl"
      :width="mouldingPlateWidth"
      :height="mouldingPlateHeight"
      preserveAspectRatio="none"
    />
    <text
      class="line1"
      :font-size="0.1"
      :letter-spacing="0.002"
      font-family="Apercu-Monospace"
      fill="#534531"
      text-anchor="middle"
      :x="mouldingPlateTextX"
      :y="mouldingPlateTextY1"
      dominant-baseline="middle"
    >
      {{ mouldingPlate.line1 }}
    </text>
    <text
      v-if="mouldingPlate.line2"
      class="line2"
      :font-size="0.1"
      :letter-spacing="0.002"
      font-family="Apercu-Monospace"
      fill="#534531"
      text-anchor="middle"
      :x="mouldingPlateTextX"
      :y="mouldingPlateTextY2"
      dominant-baseline="middle"
    >
      {{ mouldingPlate.line2 }}
    </text>
  </svg>
</template>

<script>
export default {
  props: {
    mouldingPlate: {
      type: Object,
      required: true
    },
    mouldingPlateX: {
      type: Number,
      required: true
    },
    mouldingPlateY: {
      type: Number,
      required: true
    },
    mouldingPlateWidth: {
      type: Number,
      required: true
    },
    mouldingPlateHeight: {
      type: Number,
      required: true
    }
  },
  computed: {
    mouldingPlateImageUrl() {
      return "https://cdn.framebridge.com/production/page_addition_assets/354/assets/original/Moulding_Plate_Brass.png?1585171094";
    },
    mouldingPlateTextX() {
      return this.mouldingPlateWidth / 2;
    },
    mouldingPlateTextY1() {
      return this.mouldingPlate.line2 ? 0.195 : this.mouldingPlateHeight / 2;
    },
    mouldingPlateTextY2() {
      return this.mouldingPlate.line1 ? 0.315 : this.mouldingPlateHeight / 2;
    }
  }
};
</script>

<style scoped>
/* No styles needed */
</style>
